export default __webpack_public_path__ + "static/media/compoteAndCreamJars.74855832.png";